<template>
  <div class="policyResourceSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="companyIdCookie == 1">
        <Col span="6">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('RAM.common.PleaseSelectCompany')"
            :transfer="true"
          >
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="6">
        <Input
          v-model="iamPolicyName"
          :placeholder="$t('RAM.AWS.IAM.Group.pleaseEnterPolicyName')"
        />
      </Col>
      <Col span="4">
        <Button
          v-hasPermission="[
            'resourceConfigurationManagement:aws:iamConfig:policyResource:page'
          ]"
          type="primary"
          @click="search"
          >{{ $t("message.select") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../../../utils/cookieUtil.js";
import TablePolicyResource from "../policy/TablePolicyResource";
var tablePolicyResource = TablePolicyResource;
export default {
  name: "PolicyResourceSearch",
  data() {
    return {
      companyIdCookie: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      iamPolicyName: ""
    };
  },
  mounted: function() {
    // 查询公司下拉框
    this.getCompanyDropDownBox();
  },
  methods: {
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    },
    search: function() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("iamPolicyName", this.iamPolicyName);
      tablePolicyResource.methods.showAll();
    }
  }
};
</script>
<style scoped>
.policyResourceSearch {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/iam_config/policy/PolicyResourceSearch.vue